export default __webpack_public_path__ + "static/media/b27.225ccb69.png";